import { memo, useMemo } from 'react'
import Table from '../../../../../components/Table'
import { IChatManagementReport } from '../models'
import { drillSelection, successTreatmentLabel } from '../viewModel'
import { countCell, DrillHandler, makeDrillCell, percentCell, ReportSection } from './ReportParts'
import styles from './ChatbotManagementReport.module.scss'

function OutcomeDefinitionsTab({ report, onDrill }: { report: IChatManagementReport; onDrill?: DrillHandler }) {
  const columns = useMemo(
    () => [
      { Header: 'Kod', accessor: 'code', Cell: makeDrillCell(onDrill, row => drillSelection.outcome(row.code)) },
      { Header: 'Anlamı', accessor: 'label' },
      { Header: 'Atanma kuralı', accessor: 'rule' },
      { Header: 'Kullanıcı ne görür', accessor: 'userSees' },
      { Header: 'Yorum', accessor: 'interpretation' },
      { Header: 'Adet', accessor: 'count', Cell: countCell },
      { Header: 'Pay', accessor: 'share', Cell: percentCell },
      { Header: 'Başarı Sayılır?', accessor: 'treatment' },
    ],
    [onDrill]
  )
  const rows = useMemo(
    () =>
      report.Outcomes.map(row => ({
        code: row.Code,
        label: row.Label,
        rule: row.AssignmentRule,
        userSees: row.UserSees,
        interpretation: row.Interpretation,
        count: row.Count,
        share: row.Share,
        treatment: successTreatmentLabel(row.SuccessTreatment),
      })),
    [report]
  )

  const categoryColumns = useMemo(
    () => [
      { Header: 'Kategori', accessor: 'label' },
      { Header: 'Açıklama', accessor: 'description' },
      { Header: 'Yanıt türleri', accessor: 'outcomes' },
      { Header: 'Başarı Sayılır?', accessor: 'treatment' },
    ],
    []
  )
  const categoryRows = useMemo(
    () =>
      report.Categories.map(row => ({
        label: row.Label,
        description: row.Description,
        outcomes: row.Outcomes.join(', '),
        treatment: successTreatmentLabel(row.SuccessTreatment),
      })),
    [report]
  )

  return (
    <div className={styles.reportBody}>
      <ReportSection title='Yanıt Türü Tanımları'>
        <p className={styles.sectionLead}>
          Tanımlar sunucudaki tek katalogdan gelir (ADR-021). "Başarı Sayılır?" sütunu bu sayfadaki bütün oranların
          temelidir; iptal edilen istekler başarı oranının paydasına girmez.
        </p>
        <div className={styles.tableCard}>
          <Table columns={columns} data={rows} />
        </div>
      </ReportSection>
      <ReportSection title='Performans Kategorileri'>
        <div className={styles.tableCard}>
          <Table columns={categoryColumns} data={categoryRows} />
        </div>
      </ReportSection>
    </div>
  )
}

// Kabın tarih taslağı ve detay penceresi durumu değişince ağır sekme (tablolar, grafikler) yeniden çizilmesin.
export default memo(OutcomeDefinitionsTab)
